// extracted by mini-css-extract-plugin
module.exports = {"dot_flashing":"styles-module__dot_flashing___5McYf","dotFlashing":"styles-module__dotFlashing___j3Os3","loading_button":"styles-module__loading_button___cq+oP"};